import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { EditRegistruComponent } from '../../edit-registru/edit-registru.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-construire-desfiintare',
    templateUrl: './construire-desfiintare.component.html',
    styleUrls: ['./construire-desfiintare.component.scss']
})
export class ConstruireDesfiintareComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    @Input() isEditColumnVisible: boolean = false;
    @Input() registru_slug!: string;
    @Input() registru_type!: number;

    @Input() selectedStartDate!: string;
    @Input() selectedEndDate!: string;

    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Output() extractedDTparams = new EventEmitter();
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.registru.listDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
    ) { }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isEditColumnVisible'] && !changes['isEditColumnVisible'].firstChange) {
            this.toggleEditColumnVisibility();
        }
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type = this.registru_type;
                dataTablesParameters.slug = this.registru_slug;
                dataTablesParameters.date_from = this.selectedStartDate;
                dataTablesParameters.date_to = this.selectedEndDate;

                this.extractedDTparams.emit(dataTablesParameters);

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'Număr registru și data',
                    data: 'registru_number',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.registru_number) {
                            return `<span>${row.registru_number}</span><span> - ${row.registru_date}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Număr cerere și data',
                    data: 'solicitare',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.solicitare) {
                            return `<span>${row.solicitare}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Adresă imobil',
                    data: null,
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.adresa_imobil) {
                            const adresa = row.adresa_imobil;
                            const strada = adresa.strada ? 'Str: ' + adresa.strada : '';
                            const nr = adresa.numar ? ', nr: ' + adresa.numar : '';
                            const bl = adresa.bloc ? ', bl: ' + adresa.bloc : '';
                            const sc = adresa.scara ? ', sc: ' + adresa.scara : '';
                            const et = adresa.etaj ? ', et: ' + adresa.etaj : '';
                            const ap = adresa.apartament ? ', ap: ' + adresa.apartament : '';
                            return `<span>${strada + nr + bl + sc + et + ap}</span>`;
                        }
                        // Fallback on the flat address columns the registru row carries itself
                        if (row.strada_name) {
                            const strada = 'Str: ' + row.strada_name;
                            const nr = row.nr ? ', nr: ' + row.nr : '';
                            const bl = row.bl ? ', bl: ' + row.bl : '';
                            const sc = row.scara ? ', sc: ' + row.scara : '';
                            const et = row.et ? ', et: ' + row.et : '';
                            const ap = row.ap ? ', ap: ' + row.ap : '';
                            return `<span>${strada + nr + bl + sc + et + ap}</span>`;
                        }
                        return '<span>Adresă indisponibilă</span>';
                    },
                },
                {
                    title: 'Număr cadastral',
                    data: 'nr_cadastral',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.nr_cadastral) {
                            return `<span>${row.nr_cadastral}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Număr extras de carte funciară',
                    data: 'extras_carte_funciara',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.extras_carte_funciara) {
                            return `<span>${row.extras_carte_funciara}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Scopul',
                    data: 'scop',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.scop) {
                            return `<span>${row.scop}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Solicitant',
                    data: 'solicitant',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.solicitant) {
                            return `<span>${row.solicitant}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Întocmitor',
                    data: 'intocmitor',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.intocmitor) {
                            return `<span>${row.intocmitor}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    visible: false,
                    render: () => {
                        return `
                            <button class="action-btn edit">
                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                            </button>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;

                if (editIcon) {
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditRegistruComponent, {
            ...this.dialogService.getDialogConfig(),
            data: { data, slug: this.registru_slug }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Registru editat cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => this.rerenderDT());
            }
        });
    }

    toggleEditColumnVisibility(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.columns(8).visible(this.isEditColumnVisible);
        });

        this.rerenderDT();
    }
}
